import { render, staticRenderFns } from "./UplodeMultiple.vue?vue&type=template&id=5740cf56&scoped=true"
import script from "./UplodeMultiple.vue?vue&type=script&lang=js"
export * from "./UplodeMultiple.vue?vue&type=script&lang=js"
import style0 from "./UplodeMultiple.vue?vue&type=style&index=0&id=5740cf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740cf56",
  null
  
)

export default component.exports